import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AES, enc } from "crypto-js";
import { useProjectDetails } from "../../../features/projects/ProjectList.jsx";
import { useClientView } from "../../../components/TimeTracker/TimeTrackerClient/useClientDetails.jsx";
import { setHeaderText } from "../../../features/headerText/headerTextSlice";
import { setSideBarText } from "../../../features/sideBarText/sideBarTextSlice.js";
import MvpSprintDetails from "./modules/MvpSprintDetails";

export default function SprintDetails() {
  const dispatch = useDispatch();
  const { encryptedId, projectId, sprintId } = useParams();
  const decodedId = decodeURIComponent(encryptedId.replace(/%2F/g, "/"));
  const id = AES.decrypt(decodedId, "encryptionKey").toString(enc.Utf8);
  const token = useSelector((state) => state.auth.token);
  const { data: project = {}, isLoading } = useProjectDetails(token, projectId);
  const { data: client = {} } = useClientView(id, token);

  useEffect(() => {
    dispatch(setHeaderText(client?.client_name || client?.legal_entity_name || "Client Overview"));
    dispatch(setSideBarText("Client Overview"));
  }, [client, dispatch]);

  return (
    <div className="clint-managment client-management-project">
      <MvpSprintDetails
        clientId={id}
        encryptedId={encryptedId}
        project={project}
        sprintId={sprintId}
        isLoading={isLoading}
        currency={client?.preferred_currency || "USD"}
      />
    </div>
  );
}
